import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};

type TDataVariables = {
  verificationId: string;
  accept: boolean;
};
type TResponseData = void;

export const useRequestVerifyBio = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending: isLoadingVerification, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.verifications.bio, 'verify'],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .post<TResponseData>(routes.api.verifications.bio, data)
        .then(handleApiResponse),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      invalidateRelatedQueries()
    )
  });

  const invalidateRelatedQueries = () =>
    Promise
      .all([
        invalidate(routes.api.verifications.completed),
        invalidate(routes.api.verifications.bio),
        invalidate(routes.api.dashboard)
      ]);

  const triggerVerification = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    invalidateRelatedQueries,
    isLoadingVerification,
    triggerVerification,
    error
  });

};  
